import React from "react";
import { Element } from "react-scroll";
import { useSelector } from "react-redux";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import useFreshProducts from "./useFreshProducts";
import useProcessedProducts from "./useProcessedProducts";
import textData from "./farmProductCopy";
import FarmProductsPreviewList from "./FarmProductsPreviewList";
import { scrollToFarmSection } from "../start/farmNavigationScroll";

function FarmProductsNew() {
  const userLanguage = useSelector((state) => state.app.language);
  const fresh = useFreshProducts();
  const processed = useProcessedProducts();
  const showFresh = !fresh.error && fresh.products.length > 0;
  const showProcessed = !processed.error && processed.products.length > 0;

  if (!showFresh && !showProcessed && !fresh.loading && !processed.loading && !fresh.error && !processed.error) return null;

  return (
    <Element name="farm/products" className="FarmProducts" id="farm-products">
      {showFresh && <section className="FarmProductGroup FarmProductsFresh" aria-labelledby="farm-fresh-heading">
        <div className="FarmLandingContainer">
          <header className="FarmLandingSectionHeading FarmProductsHeading">
            <h2 id="farm-fresh-heading">{textData.freshHeading[userLanguage]}</h2>
            <p className="FarmProductsStatement">{textData.title[userLanguage]}</p>
            <p className="FarmLandingSectionIntro">{textData.subtitle[userLanguage]}</p>
          </header>
          <FarmProductsPreviewList products={fresh.products} kind="fresh" language={userLanguage} />
          {!showProcessed && <button className="FarmProductsMore" type="button" onClick={() => scrollToFarmSection("farm/contact")}>{textData.more[userLanguage]}<ArrowForwardIcon /></button>}
        </div>
      </section>}
      {showProcessed && <section className="FarmProductGroup FarmProductsProcessed" aria-labelledby="farm-processed-heading">
        <div className="FarmLandingContainer">
          <header className="FarmLandingSectionHeading FarmProductsHeading">
            <h2 id="farm-processed-heading">{textData.processedHeading[userLanguage]}</h2>
            {textData.processedIntro.map((paragraph, index) => <p className="FarmLandingSectionIntro" key={index}>{paragraph[userLanguage]}</p>)}
          </header>
          <FarmProductsPreviewList products={processed.products} kind="processed" language={userLanguage} />
          <button className="FarmProductsMore" type="button" onClick={() => scrollToFarmSection("farm/contact")}>{textData.more[userLanguage]}<ArrowForwardIcon /></button>
        </div>
      </section>}
      {(fresh.loading || processed.loading || fresh.error || processed.error) && <div className="FarmProductsFeedback FarmLandingContainer">
        {(fresh.loading || processed.loading) && <p className="FarmLandingState" role="status">{userLanguage === 0 ? "Hämtar produkter…" : "Loading products…"}</p>}
        {fresh.error && <div className="FarmLandingState" role="alert">
          <p>{userLanguage === 0 ? "Färska produkter kunde inte hämtas." : "Fresh products could not be loaded."}</p>
          <button type="button" onClick={fresh.retry}>{userLanguage === 0 ? "Försök igen" : "Try again"}</button>
        </div>}
        {processed.error && <div className="FarmLandingState" role="alert">
          <p>{userLanguage === 0 ? "Processade produkter kunde inte hämtas." : "Processed products could not be loaded."}</p>
          <button type="button" onClick={processed.retry}>{userLanguage === 0 ? "Försök igen" : "Try again"}</button>
        </div>}
      </div>}
    </Element>
  );
}

export default FarmProductsNew;
